import React, { useEffect, useState } from "react";

const Popup = ({ message, show, onClose, duration = 3000 }) => {
  const [visible, setVisible] = useState(false);
  const [initialRender, setInitialRender] = useState(true);

  useEffect(() => {
    let timer;
    if (show) {
      setVisible(true);
      setInitialRender(false);
      timer = setTimeout(() => {
        setVisible(false);
        setTimeout(onClose, 500); // Wait for the slide-out animation to complete before calling onClose
        setTimeout(() => setInitialRender(true), 1000); // Wait for the slide-out animation to complete before calling onClose
      }, duration);
    }
    /*   return () => {
      if (timer) {
        clearTimeout(timer);
      }
    }; */
  }, [show, onClose, duration]);

  return (
    <div
      className={
        initialRender
          ? "popup popup-initial"
          : `popup ${visible ? "popup-show" : "popup-hide"}`
      }
    >
      {message}
    </div>
  );
};

export default Popup;
